export default {
    key: 'support-services',
    label: 'Support services',
    component: {
        name: 'SupportServicesTemplate',
        loader: () => import('./SupportServicesTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Modules',
                name: 'default'
            },
        ]
    }
};
